import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { z } from 'zod';

import { NewRuleOs } from '~/features/connectors/new-rule-os';

/** `?q=` what was asked on the Gmail page; `?replaces=` the rule to change. Both are read once and leave the address. */
const search = z.object({
  q: z.string().optional().catch(undefined),
  replaces: z.string().optional().catch(undefined),
});

function NewRuleRoute(): ReactElement {
  const { q, replaces } = Route.useSearch();
  return <NewRuleOs q={q ?? null} replaces={replaces ?? null} />;
}

/** A new Gmail rule, made with OS (boards R0, R0b). */
export const Route = createFileRoute('/_app/business/connectors/gmail/rules/new')({
  validateSearch: search,
  component: NewRuleRoute,
});
